var shadow = {
  color: "rgb(0 0 0 / 12%)",
  depth: {
    100: "0px 8px",
    200: "0px 12px",
    300: "2px 16px",
    400: "4px 20px",
    500: "8px 24px",
    600: "12px 28px"
  }
};
var base = {
  100: "0 " + shadow.depth[100] + " " + shadow.color,
  200: "0 " + shadow.depth[200] + " " + shadow.color,
  300: "0 " + shadow.depth[300] + " " + shadow.color,
  400: "0 " + shadow.depth[400] + " " + shadow.color,
  500: "0 " + shadow.depth[500] + " " + shadow.color,
  600: "0 " + shadow.depth[600] + " " + shadow.color
};
var shadows = {
  100: base[100],
  200: base[200],
  300: base[300],
  400: base[400],
  500: base[500],
  600: base[600],
  card: base[300],
  dropdown: base[400],
  dialog: base[600]
};
export { shadows as default, shadow, shadows };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
